import React, { useState, useEffect } from "react";
import Footer from "./Footer";
import HomePage from "./HomePage";
import "./tbcurrent.css";
import { Link } from "react-router-dom";

function Pricing() {
  const [stylingOnClickPricing, setstylingOnClickPricing] = useState();
  useEffect(() => {
    setstylingOnClickPricing("MediumBlue");
  }, []);

  const [view, setView] = useState("segment");

  // Dark mode detection
  const [isDarkMode, setIsDarkMode] = useState(
    typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
  );
  useEffect(() => {
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (e) => setIsDarkMode(e.matches);
    if (media.addEventListener) media.addEventListener("change", handler);
    else media.addListener(handler);
    return () => {
      if (media.removeEventListener)
        media.removeEventListener("change", handler);
      else media.removeListener(handler);
    };
  }, []);

  // Pricing Calculator State
  const [calculatorClients, setCalculatorClients] = useState(51);
  const [calculatorEmployees, setCalculatorEmployees] = useState(0);
  const [calculatorPlan, setCalculatorPlan] = useState("pro"); // "starter" or "pro"
  const [currentMonthlyCost, setCurrentMonthlyCost] = useState("");

  // Practice Pricing Calculator State (NEW)
  const [practiceClients, setPracticeClients] = useState(25);
  const [practiceEmployees, setPracticeEmployees] = useState(3);
  const [selectedPracticeTier, setSelectedPracticeTier] = useState(1); // 0=Starter, 1=Growth, 2=Enterprise

  // Partner Tier System - "Best of Both Worlds" Model
  const partnerTiers = [
    {
      name: "Bronze Partner",
      minClients: 5,
      discount: 0,
      badge: "🥉",
      reward: "50 Free PDF Credits",
      description: "Get started with wholesale pricing",
    },
    {
      name: "Silver Partner",
      minClients: 25,
      discount: 20,
      badge: "🥈",
      reward: "20% Discount on Total Bill",
      description: "Save R1,000s with volume pricing",
    },
    {
      name: "Gold Partner",
      minClients: 51,
      discount: 40,
      badge: "🥇",
      reward: "40% Discount on Total Bill",
      description: "Maximize your profit margins",
      popular: true,
    },
    {
      name: "Platinum Partner",
      minClients: 101,
      discount: 50,
      badge: "💎",
      reward: "50% Discount on Total Bill",
      description: "Elite partner pricing",
    },
  ];

  // NEW: Practice-Specific Pricing Tiers (for new signups only)
  const practicePricingTiers = [
    {
      name: "Starter Practice",
      monthlyPrice: 399,
      includedClients: 10,
      // No employees included - R18 per employee per company
      additionalClientPrice: 50,
      badge: "🚀",
      description: "New practices",
      features: [
        "Invoicing",
        "Automated allocations",
        "PDF to CSV",
        "Provisional tax",
        "Financial reports",
        "CIPC reminders & client approvals",
      ],
    },
    {
      name: "Pro Practice",
      monthlyPrice: 999,
      includedClients: 20,
      // No employees included - R18 per employee per company
      additionalClientPrice: 50,
      badge: "⭐",
      description: "Most popular",
      popular: true,
      features: [
        "Everything in Starter",
        "AI-powered allocations",
        "Client Portal",
        "Task Manager",
        "Compliance Portal",
        "Engagement templates",
        "Working papers",
        "20 clients included",
        "R50/extra client",
        "R18/employee",
      ],
    },
    {
      name: "Growth Practice",
      monthlyPrice: 1499,
      includedClients: 50,
      // No employees included - R18 per employee per company
      additionalClientPrice: 50,
      badge: "📈",
      description: "Growing practices",
      features: [
        "Everything in Pro",
        "50 clients included",
        "R50/extra client",
        "R18/employee",
      ],
    },
    {
      name: "Enterprise Practice",
      monthlyPrice: 3499,
      includedClients: 150,
      // No employees included - R18 per employee per company
      additionalClientPrice: 50,
      badge: "💼",
      description: "Established firms",
      features: [
        "Everything in Growth",
        "150 clients included",
        "R50/extra client",
        "R18/employee",
      ],
    },
  ];

  // Prepaid PDF Credit Packs
  const pdfCreditPacks = [
    { pages: 500, price: 1000, pricePerPage: 2.0, badge: "Starter" },
    {
      pages: 2000,
      price: 3600,
      pricePerPage: 1.8,
      badge: "Professional",
      savings: "10% off",
    },
    {
      pages: 5000,
      price: 8500,
      pricePerPage: 1.7,
      badge: "Growth",
      savings: "15% off",
      popular: true,
    },
    {
      pages: 10000,
      price: 16000,
      pricePerPage: 1.6,
      badge: "Enterprise",
      savings: "20% off",
    },
  ];

  const [open, setOpen] = useState({});

  const handleOpen = (id) => {
    setOpen({ ...open, [id]: true });
  };
  const handleClose = (id) => {
    setOpen({ ...open, [id]: false });
  };

  function QuestionAnswer(elText1, elText2, elID) {
    return (
      <div
        style={{
          backgroundColor: isDarkMode ? "#1f2937" : "#f8fafc",
          border: "1px solid #e2e8f0",
          borderRadius: "16px",
          marginBottom: "16px",
          overflow: "hidden",
          transition: "all 0.3s ease",
        }}
      >
        <div
          style={{
            padding: "24px",
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          onClick={() => (open[elID] ? handleClose(elID) : handleOpen(elID))}
        >
          <h3
            style={{
              fontSize: "1.2rem",
              fontWeight: "600",
              color: isDarkMode ? "#f3f4f6" : "#1e293b",
              margin: 0,
              flex: 1,
              textAlign: "left",
            }}
          >
            {elText1}
          </h3>
          <div
            style={{
              width: "40px",
              height: "40px",
              backgroundColor: open[elID] ? "#3b82f6" : "#e2e8f0",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.3s ease",
              flexShrink: 0,
              marginLeft: "16px",
            }}
          >
            {open[elID] ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="white"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="#64748b"
                viewBox="0 0 16 16"
              >
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
              </svg>
            )}
          </div>
        </div>
        {open[elID] && (
          <div
            style={{
              padding: "0 24px 24px",
              borderTop: "1px solid #e2e8f0",
              backgroundColor: isDarkMode ? "#111827" : "white",
            }}
          >
            <p
              style={{
                color: isDarkMode ? "#cbd5e1" : "#64748b",
                fontSize: "1rem",
                lineHeight: "1.6",
                margin: "16px 0 0 0",
              }}
            >
              {elText2}
            </p>
          </div>
        )}
      </div>
    );
  }

  return (
    <div>
      <HomePage stylingOnClickPricing={stylingOnClickPricing} />

      {/* Modern Hero Section */}
      <div
        style={{
          background: isDarkMode
            ? "linear-gradient(45deg, #0c4a6e, #064e3b)"
            : "linear-gradient(45deg, rgb(189, 243, 255), rgb(238, 255, 247))",
          padding: "80px 20px",
          paddingTop: "140px",
          textAlign: "center",
          marginBottom: "0",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          <h1
            style={{
              fontSize: "clamp(2.5rem, 5vw, 4rem)",
              fontWeight: "700",
              marginBottom: "20px",
              color: isDarkMode ? "#f2f3f7ff" : "#1e293b",
              fontFamily:
                "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
            }}
          >
            Simple Pricing.
          </h1>
          <p
            className="pricing-hero-features"
            style={{
              color: isDarkMode ? "#f2f3f7ff" : "#1e293b",
              fontFamily:
                "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
            }}
          >
            Start for free. Scale with your business.
          </p>
        </div>
      </div>

      {/* Free Accounting Practice Demo Banner */}
      <div
        style={{
          background: isDarkMode
            ? "linear-gradient(135deg, #065f46 0%, #047857 100%)"
            : "linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)",
          padding: "32px 20px",
          borderTop: "3px solid #10b981",
          borderBottom: "3px solid #10b981",
        }}
      >
        <div
          style={{
            maxWidth: "1000px",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          <div style={{ fontSize: "3rem", marginBottom: "12px" }}>🎉</div>
          <h2
            style={{
              fontSize: "clamp(1.5rem, 3vw, 2rem)",
              fontWeight: "700",
              color: isDarkMode ? "#bbf7d0" : "#065f46",
              marginBottom: "12px",
            }}
          >
            FREE Company for Accounting Practices
          </h2>
          <p
            style={{
              fontSize: "1.1rem",
              color: isDarkMode ? "#86efac" : "#047857",
              marginBottom: "16px",
              lineHeight: "1.6",
            }}
          >
            Start with a <strong>free company</strong>. No credit card required.
          </p>
          <div
            style={{
              display: "inline-flex",
              gap: "24px",
              flexWrap: "wrap",
              justifyContent: "center",
              marginTop: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                color: isDarkMode ? "#86efac" : "#065f46",
                fontWeight: "600",
              }}
            >
              <span style={{ fontSize: "1.5rem" }}>✓</span>
              <span>No Credit Card Required</span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                color: isDarkMode ? "#86efac" : "#065f46",
                fontWeight: "600",
              }}
            >
              <span style={{ fontSize: "1.5rem" }}>✓</span>
              <span>Free</span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                color: isDarkMode ? "#86efac" : "#065f46",
                fontWeight: "600",
              }}
            >
              <span style={{ fontSize: "1.5rem" }}>✓</span>
              <span>Full Platform Access</span>
            </div>
          </div>
          <div style={{ marginTop: "24px" }}>
            <Link
              to="/Signup"
              style={{
                display: "inline-block",
                padding: "14px 32px",
                background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                color: "white",
                textDecoration: "none",
                borderRadius: "12px",
                fontWeight: "700",
                fontSize: "1.1rem",
                boxShadow: "0 4px 15px rgba(16, 185, 129, 0.3)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 6px 20px rgba(16, 185, 129, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 4px 15px rgba(16, 185, 129, 0.3)";
              }}
            >
              Get Started →
            </Link>
          </div>
        </div>
      </div>

      {/* Segmentation fork */}
      {view === "segment" && (
        <div
          style={{ maxWidth: "1000px", margin: "0 auto", padding: "80px 20px" }}
        >
          <h1
            style={{
              fontSize: "clamp(2rem, 4vw, 2.5rem)",
              fontWeight: "700",
              textAlign: "center",
              marginBottom: "16px",
              color: isDarkMode ? "#010206ff" : "#1e293b",
            }}
          >
            Pricing.
          </h1>
          <p
            style={{
              fontSize: "1.2rem",
              color: isDarkMode ? "#cbd5e1" : "#64748b",
              textAlign: "center",
              marginBottom: "60px",
            }}
          >
            Choose your plan.
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "30px",
            }}
          >
            {/* Card 1: The Partner */}
            <div
              style={{
                backgroundColor: isDarkMode ? "#111827" : "white",
                color: isDarkMode ? "#f3f4f6" : "inherit",
                borderRadius: "24px",
                padding: "40px 30px",
                boxShadow: "0 10px 40px rgba(59, 130, 246, 0.1)",
                border: "2px solid #e2e8f0",
                display: "flex",
                flexDirection: "column",
                transition: "all 0.3s ease",
                cursor: "pointer",
              }}
              onClick={() => setView("partner")}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 20px 60px rgba(59, 130, 246, 0.2)";
                e.currentTarget.style.borderColor = "#3b82f6";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 10px 40px rgba(59, 130, 246, 0.1)";
                e.currentTarget.style.borderColor = "#e2e8f0";
              }}
            >
              <div
                style={{
                  fontSize: "3rem",
                  marginBottom: "20px",
                  textAlign: "center",
                }}
              >
                👨‍💼
              </div>
              <h2
                style={{
                  fontSize: "1.8rem",
                  fontWeight: "700",
                  marginBottom: "16px",
                  color: isDarkMode ? "#f3f4f6" : "#1e293b",
                  textAlign: "center",
                }}
              >
                For My Accounting Practice
              </h2>
              <p
                style={{
                  fontSize: "1rem",
                  color: isDarkMode ? "#cbd5e1" : "#64748b",
                  marginBottom: "30px",
                  flexGrow: 1,
                  lineHeight: "1.6",
                  textAlign: "center",
                }}
              >
                Managing multiple clients
              </p>
              <button
                onClick={() => setView("partner")}
                style={{
                  width: "100%",
                  padding: "16px",
                  backgroundColor: "#3b82f6",
                  color: "white",
                  border: "none",
                  borderRadius: "12px",
                  fontSize: "1.1rem",
                  fontWeight: "700",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#2563eb";
                  e.target.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#3b82f6";
                  e.target.style.transform = "translateY(0)";
                }}
              >
                See Partner Pricing
              </button>
            </div>

            {/* Card 2: The Business */}
            <div
              style={{
                backgroundColor: isDarkMode ? "#111827" : "white",
                color: isDarkMode ? "#f3f4f6" : "inherit",
                borderRadius: "24px",
                padding: "40px 30px",
                boxShadow: "0 10px 40px rgba(71, 85, 105, 0.1)",
                border: "2px solid #e2e8f0",
                display: "flex",
                flexDirection: "column",
                transition: "all 0.3s ease",
                cursor: "pointer",
              }}
              onClick={() => setView("business")}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 20px 60px rgba(71, 85, 105, 0.2)";
                e.currentTarget.style.borderColor = "#475569";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 10px 40px rgba(71, 85, 105, 0.1)";
                e.currentTarget.style.borderColor = "#e2e8f0";
              }}
            >
              <div
                style={{
                  fontSize: "3rem",
                  marginBottom: "20px",
                  textAlign: "center",
                }}
              >
                🏢
              </div>
              <h2
                style={{
                  fontSize: "1.8rem",
                  fontWeight: "700",
                  marginBottom: "16px",
                  color: isDarkMode ? "#f3f4f6" : "#1e293b",
                  textAlign: "center",
                }}
              >
                For My Business
              </h2>
              <p
                style={{
                  fontSize: "1rem",
                  color: isDarkMode ? "#cbd5e1" : "#64748b",
                  marginBottom: "30px",
                  flexGrow: 1,
                  lineHeight: "1.6",
                  textAlign: "center",
                }}
              >
                Single business
              </p>
              <button
                onClick={() => setView("business")}
                style={{
                  width: "100%",
                  padding: "16px",
                  backgroundColor: "#475569",
                  color: "white",
                  border: "none",
                  borderRadius: "12px",
                  fontSize: "1.1rem",
                  fontWeight: "700",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#334155";
                  e.target.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#475569";
                  e.target.style.transform = "translateY(0)";
                }}
              >
                See Business Pricing
              </button>
            </div>
          </div>
        </div>
      )}

      {/* PARTNER VIEW - New Simplified Pricing */}
      {view === "partner" && (
        <div
          style={{ maxWidth: "1200px", margin: "0 auto", padding: "80px 20px" }}
        >
          {false && ( // HIDING OLD PRICING SECTIONS
          <>
          {/* Hero Section */}
          <div style={{ textAlign: "center", marginBottom: "80px" }}>
            <h1
              style={{
                fontSize: "clamp(2rem, 4vw, 3rem)",
                fontWeight: "700",
                marginBottom: "20px",
                color: isDarkMode ? "#091b41ff" : "#1e293b",
              }}
            >
              Partner Program: Per-Client Pricing with Volume Rewards
            </h1>
            <p
              style={{
                fontSize: "1.2rem",
                color: isDarkMode ? "#0c294cff" : "#64748b",
                marginBottom: "40px",
                maxWidth: "800px",
                margin: "0 auto 40px",
                lineHeight: "1.6",
              }}
            >
              Start with simple per-client pricing. Unlock automatic discounts
              as you grow. Zero long-term commitments.
            </p>
            <Link to="/signup">
              <button
                style={{
                  backgroundColor: "#3b82f6",
                  color: "white",
                  fontWeight: "700",
                  padding: "18px 40px",
                  borderRadius: "12px",
                  fontSize: "1.1rem",
                  border: "none",
                  cursor: "pointer",
                  boxShadow: "0 10px 30px rgba(59, 130, 246, 0.3)",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#2563eb";
                  e.target.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#3b82f6";
                  e.target.style.transform = "translateY(0)";
                }}
              >
                Join Partner Program (Free)
              </button>
            </Link>
          </div>

          {/* Foundation Plans - Per-Client Pricing */}
          <div style={{ marginBottom: "80px" }}>
            <h2
              style={{
                fontSize: "2rem",
                fontWeight: "700",
                marginBottom: "16px",
                textAlign: "center",
                color: isDarkMode ? "#0e2045ff" : "#1e293b",
              }}
            >
              Accounting Plans
            </h2>
            <p
              style={{
                fontSize: "1.1rem",
                color: isDarkMode ? "#0e233dff" : "#64748b",
                textAlign: "center",
                marginBottom: "40px",
                maxWidth: "700px",
                margin: "0 auto 40px",
              }}
            >
              Per-client pricing.
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(380px, 1fr))",
                gap: "40px",
                maxWidth: "900px",
                margin: "0 auto",
              }}
            >
              {/* Starter Plan */}
              <div
                style={{
                  backgroundColor: isDarkMode ? "#111827" : "white",
                  color: isDarkMode ? "#f3f4f6" : "inherit",
                  borderRadius: "24px",
                  padding: "40px 30px",
                  boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
                  border: "2px solid #e2e8f0",
                }}
              >
                <div
                  style={{
                    fontSize: "2.5rem",
                    marginBottom: "16px",
                    textAlign: "center",
                  }}
                >
                  📊
                </div>
                <h3
                  style={{
                    fontSize: "1.8rem",
                    fontWeight: "700",
                    marginBottom: "12px",
                    color: isDarkMode ? "#f3f4f6" : "#1e293b",
                    textAlign: "center",
                  }}
                >
                  FilingStack Starter
                </h3>
                <p
                  style={{
                    fontSize: "0.85rem",
                    color: "#64748b",
                    textAlign: "center",
                    marginBottom: "16px",
                    fontStyle: "italic",
                  }}
                >
                  Essentials
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    justifyContent: "center",
                    gap: "8px",
                    marginBottom: "24px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "3rem",
                      fontWeight: "800",
                      color: "#3b82f6",
                    }}
                  >
                    R70
                  </div>
                  <div
                    style={{
                      fontSize: "1rem",
                      color: "#64748b",
                      fontWeight: "500",
                    }}
                  >
                    /client/month
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  {[
                    "Accounting & trial balance",
                    "Financial statements",
                    "VAT calculations",
                    "Client portal",
                    "Tasks",
                    "Payroll: R18/employee",
                  ].map((feature, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="#3b82f6"
                        viewBox="0 0 16 16"
                        style={{ flexShrink: 0, marginTop: "2px" }}
                      >
                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                      </svg>
                      <span
                        style={{
                          fontSize: "0.95rem",
                          color: isDarkMode ? "#cbd5e1" : "#475569",
                          lineHeight: "1.5",
                        }}
                      >
                        {feature}
                      </span>
                    </div>
                  ))}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "12px",
                    }}
                  >
                    <span
                      style={{
                        color: "#ef4444",
                        fontSize: "1.1rem",
                        fontWeight: "700",
                        lineHeight: 1,
                        marginTop: "3px",
                      }}
                    >
                      ✗
                    </span>
                    <span
                      style={{
                        fontSize: "0.95rem",
                        color: "#94a3b8",
                        lineHeight: "1.5",
                      }}
                    >
                      Compliance Portal
                    </span>
                  </div>
                </div>
              </div>

              {/* Pro Plan */}
              <div
                style={{
                  backgroundColor: isDarkMode ? "#111827" : "white",
                  color: isDarkMode ? "#f3f4f6" : "inherit",
                  borderRadius: "24px",
                  padding: "40px 30px",
                  boxShadow: "0 20px 60px rgba(59, 130, 246, 0.15)",
                  border: "3px solid #3b82f6",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "20px",
                    right: "20px",
                    backgroundColor: "#3b82f6",
                    color: "white",
                    padding: "6px 16px",
                    borderRadius: "20px",
                    fontSize: "0.85rem",
                    fontWeight: "700",
                  }}
                >
                  Most Popular
                </div>
                <div
                  style={{
                    fontSize: "2.5rem",
                    marginBottom: "16px",
                    textAlign: "center",
                  }}
                >
                  💼
                </div>
                <h3
                  style={{
                    fontSize: "1.8rem",
                    fontWeight: "700",
                    marginBottom: "12px",
                    color: isDarkMode ? "#f3f4f6" : "#1e293b",
                    textAlign: "center",
                  }}
                >
                  FilingStack Pro
                </h3>
                <p
                  style={{
                    fontSize: "0.85rem",
                    color: isDarkMode ? "#cbd5e1" : "#64748b",
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  Complete
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    justifyContent: "center",
                    gap: "8px",
                    marginBottom: "24px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "3rem",
                      fontWeight: "800",
                      color: "#3b82f6",
                    }}
                  >
                    R180
                  </div>
                  <div
                    style={{
                      fontSize: "1rem",
                      color: "#64748b",
                      fontWeight: "500",
                    }}
                  >
                    /client/month
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  {[
                    "Everything in Starter",
                    "Invoicing & quotes",
                    "AI data capture",
                    "Tax calculations",
                    "17 PDF credits/month",
                    "Payroll: R18/employee",
                  ].map((feature, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="#3b82f6"
                        viewBox="0 0 16 16"
                        style={{ flexShrink: 0, marginTop: "2px" }}
                      >
                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                      </svg>
                      <span
                        style={{
                          fontSize: "0.95rem",
                          color: isDarkMode ? "#f3f4f6" : "#1e293b",
                          lineHeight: "1.5",
                        }}
                      >
                        {feature}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Payroll Info Note */}
            <div
              style={{
                marginTop: "40px",
                backgroundColor: "#f0fdf4",
                borderRadius: "16px",
                padding: "20px 24px",
                border: "2px solid #86efac",
                maxWidth: "600px",
                margin: "40px auto 0",
                textAlign: "center",
              }}
            >
              <p
                style={{
                  fontSize: "0.95rem",
                  color: "#047857",
                  lineHeight: "1.6",
                  margin: 0,
                }}
              >
                💼 <strong>Payroll included.</strong> SARS-compliant IRP5, e@syFile, and EMP201. R18/employee/month.
              </p>
            </div>
          </div>

          {/* Partner Status Tiers - The "Volume Discount" Section */}
          <div
            style={{
              background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
              borderRadius: "24px",
              padding: "60px 40px",
              marginBottom: "80px",
              border: "2px solid #bae6fd",
            }}
          >
            <h2
              style={{
                fontSize: "2.5rem",
                fontWeight: "700",
                marginBottom: "16px",
                textAlign: "center",
                color: "#0c4a6e",
              }}
            >
              Volume Discounts
            </h2>
            <p
              style={{
                fontSize: "1.2rem",
                color: "#075985",
                textAlign: "center",
                marginBottom: "50px",
                maxWidth: "800px",
                margin: "0 auto 50px",
                lineHeight: "1.6",
              }}
            >
              More clients, bigger discounts. Applied to your entire bill.
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                gap: "24px",
                marginBottom: "40px",
              }}
            >
              {partnerTiers.map((tier, idx) => (
                <div
                  key={idx}
                  style={{
                    backgroundColor: isDarkMode ? "#111827" : "white",
                    color: isDarkMode ? "#f3f4f6" : "inherit",
                    borderRadius: "20px",
                    padding: "30px 24px",
                    border: tier.popular
                      ? "3px solid #fbbf24"
                      : "2px solid #e0f2fe",
                    boxShadow: tier.popular
                      ? "0 10px 40px rgba(251, 191, 36, 0.2)"
                      : "0 4px 15px rgba(0, 0, 0, 0.05)",
                    position: "relative",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow =
                      "0 15px 50px rgba(0, 0, 0, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = tier.popular
                      ? "0 10px 40px rgba(251, 191, 36, 0.2)"
                      : "0 4px 15px rgba(0, 0, 0, 0.05)";
                  }}
                >
                  {tier.popular && (
                    <div
                      style={{
                        position: "absolute",
                        top: "-12px",
                        right: "20px",
                        backgroundColor: "#fbbf24",
                        color: "#78350f",
                        padding: "4px 12px",
                        borderRadius: "12px",
                        fontSize: "0.75rem",
                        fontWeight: "700",
                      }}
                    >
                      MOST POPULAR
                    </div>
                  )}
                  <div
                    style={{
                      fontSize: "3.5rem",
                      textAlign: "center",
                      marginBottom: "16px",
                    }}
                  >
                    {tier.badge}
                  </div>
                  <h3
                    style={{
                      fontSize: "1.4rem",
                      fontWeight: "700",
                      color: isDarkMode ? "#f3f4f6" : "#1e293b",
                      textAlign: "center",
                      marginBottom: "8px",
                    }}
                  >
                    {tier.name}
                  </h3>
                  <p
                    style={{
                      fontSize: "0.9rem",
                      color: isDarkMode ? "#cbd5e1" : "#64748b",
                      textAlign: "center",
                      marginBottom: "20px",
                    }}
                  >
                    {tier.description}
                  </p>
                  <div
                    style={{
                      backgroundColor: "#f0f9ff",
                      borderRadius: "12px",
                      padding: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "0.85rem",
                        color: "#0369a1",
                        fontWeight: "600",
                        textAlign: "center",
                        marginBottom: "4px",
                      }}
                    >
                      Unlock at
                    </div>
                    <div
                      style={{
                        fontSize: "2rem",
                        fontWeight: "800",
                        color: isDarkMode ? "#7dd3fc" : "#0c4a6e",
                        textAlign: "center",
                      }}
                    >
                      {tier.minClients}+ clients
                    </div>
                  </div>
                  <div
                    style={{
                      backgroundColor:
                        tier.discount > 0 ? "#dcfce7" : "#fef3c7",
                      borderRadius: "12px",
                      padding: "12px",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "0.85rem",
                        color: tier.discount > 0 ? "#065f46" : "#78350f",
                        fontWeight: "600",
                        marginBottom: "4px",
                      }}
                    >
                      {tier.discount > 0 ? "Your Reward" : "Bonus Reward"}
                    </div>
                    <div
                      style={{
                        fontSize: tier.discount > 0 ? "1.8rem" : "1.2rem",
                        fontWeight: "800",
                        color: tier.discount > 0 ? "#059669" : "#ca8a04",
                      }}
                    >
                      {tier.discount > 0
                        ? `${tier.discount}% OFF`
                        : tier.reward}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Volume Discount Examples */}
            <div
              style={{
                backgroundColor: isDarkMode ? "#111827" : "white",
                color: isDarkMode ? "#f3f4f6" : "inherit",
                borderRadius: "16px",
                padding: "30px",
                border: "2px solid #e0f2fe",
              }}
            >
              <h4
                style={{
                  fontSize: "1.3rem",
                  fontWeight: "700",
                  color: "#0c4a6e",
                  marginBottom: "20px",
                  textAlign: "center",
                }}
              >
                Savings Examples (Pro @ R180/client)
              </h4>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: "20px",
                }}
              >
                {[
                  {
                    clients: 25,
                    tier: "Silver",
                    discount: 20,
                    before: 4500,
                    after: 3600,
                    savings: 900,
                  },
                  {
                    clients: 51,
                    tier: "Gold",
                    discount: 40,
                    before: 9180,
                    after: 5508,
                    savings: 3672,
                  },
                  {
                    clients: 101,
                    tier: "Platinum",
                    discount: 50,
                    before: 18180,
                    after: 9090,
                    savings: 9090,
                  },
                ].map((example, idx) => (
                  <div
                    key={idx}
                    style={{
                      backgroundColor: isDarkMode ? "#1f2937" : "#f8fafc",
                      borderRadius: "12px",
                      padding: "20px",
                      border: "1px solid #cbd5e1",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "700",
                        color: isDarkMode ? "#f3f4f6" : "#1e293b",
                        marginBottom: "8px",
                      }}
                    >
                      {example.clients} Clients
                    </div>
                    <div
                      style={{
                        fontSize: "0.85rem",
                        color: isDarkMode ? "#cbd5e1" : "#64748b",
                        marginBottom: "12px",
                      }}
                    >
                      {example.tier} Partner ({example.discount}% off)
                    </div>
                    <div
                      style={{
                        fontSize: "0.9rem",
                        color: isDarkMode ? "#cbd5e1" : "#64748b",
                        marginBottom: "4px",
                      }}
                    >
                      Before:{" "}
                      <span style={{ textDecoration: "line-through" }}>
                        R{example.before.toLocaleString()}/mo
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: "1.2rem",
                        fontWeight: "700",
                        color: "#059669",
                        marginBottom: "8px",
                      }}
                    >
                      After: R{example.after.toLocaleString()}/mo
                    </div>
                    <div
                      style={{
                        backgroundColor: "#dcfce7",
                        borderRadius: "8px",
                        padding: "8px",
                        fontSize: "0.9rem",
                        fontWeight: "600",
                        color: "#065f46",
                        textAlign: "center",
                      }}
                    >
                      Save R{example.savings.toLocaleString()}/mo
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          </>
          )} {/* END HIDDEN OLD PRICING SECTIONS */}

          {/* NEW: Practice-Specific Pricing Tiers (for new signups) */}
          <div
            style={{
              backgroundColor: "#f9fafb",
              borderRadius: "24px",
              padding: window.innerWidth <= 768 ? "40px 20px" : "60px 40px",
              marginBottom: "80px",
              border: "1px solid #e5e7eb",
            }}
          >
            <div style={{ textAlign: "center", marginBottom: "16px" }}>
              <span
                style={{
                  display: "inline-block",
                  backgroundColor: "#dc2626",
                  color: "white",
                  padding: "8px 20px",
                  borderRadius: "20px",
                  fontSize: "0.9rem",
                  fontWeight: "700",
                  marginBottom: "16px",
                }}
              >
                🆕 NEW PRICING OPTION
              </span>
            </div>
            <h2
              style={{
                fontSize: "2.5rem",
                fontWeight: "700",
                marginBottom: "16px",
                textAlign: "center",
                color: "#0c4a6e",
              }}
            >
              All-Inclusive Practice Pricing
            </h2>
            <p
              style={{
                fontSize: window.innerWidth <= 768 ? "1rem" : "1.2rem",
                color: "#0369a1",
                textAlign: "center",
                marginBottom: "50px",
                maxWidth: "900px",
                margin: "0 auto 50px",
                lineHeight: "1.6",
              }}
            >
              Tiered pricing with included clients. 
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: window.innerWidth <= 768 ? "1fr" : "repeat(auto-fit, minmax(320px, 1fr))",
                gap: window.innerWidth <= 768 ? "20px" : "30px",
                marginBottom: "40px",
              }}
            >
              {practicePricingTiers.slice(0, 3).map((tier, idx) => (
                <div
                  key={idx}
                  style={{
                    backgroundColor: "white",
                    borderRadius: "20px",
                    padding: window.innerWidth <= 768 ? "28px 20px" : "36px 28px",
                    border: tier.popular
                      ? "4px solid #10b981"
                      : "2px solid #fbbf24",
                    boxShadow: tier.popular
                      ? "0 15px 50px rgba(16, 185, 129, 0.25)"
                      : "0 8px 30px rgba(251, 191, 36, 0.2)",
                    position: "relative",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-8px)";
                    e.currentTarget.style.boxShadow =
                      "0 20px 60px rgba(0, 0, 0, 0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = tier.popular
                      ? "0 15px 50px rgba(16, 185, 129, 0.25)"
                      : "0 8px 30px rgba(251, 191, 36, 0.2)";
                  }}
                >
                  {tier.popular && (
                    <div
                      style={{
                        position: "absolute",
                        top: "-15px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "#10b981",
                        color: "white",
                        padding: "8px 24px",
                        borderRadius: "20px",
                        fontSize: "0.85rem",
                        fontWeight: "700",
                        boxShadow: "0 4px 15px rgba(16, 185, 129, 0.3)",
                      }}
                    >
                      MOST POPULAR
                    </div>
                  )}

                  <div style={{ textAlign: "center", marginBottom: "24px" }}>
                    <div
                      style={{
                        fontSize: "3rem",
                        marginBottom: "12px",
                      }}
                    >
                      {tier.badge}
                    </div>
                    <h3
                      style={{
                        fontSize: window.innerWidth <= 768 ? "1.5rem" : "1.8rem",
                        fontWeight: "700",
                        marginBottom: "8px",
                        color: "#1e293b",
                      }}
                    >
                      {tier.name}
                    </h3>
                    <p
                      style={{
                        fontSize: "0.95rem",
                        color: "#64748b",
                        marginBottom: "20px",
                      }}
                    >
                      {tier.description}
                    </p>

                    <div style={{ marginBottom: "16px" }}>
                      <div
                        style={{
                          fontSize: window.innerWidth <= 768 ? "2.8rem" : "3.5rem",
                          fontWeight: "800",
                          color: "#3b82f6",
                          lineHeight: "1",
                        }}
                      >
                        R{tier.monthlyPrice}
                      </div>
                      <div
                        style={{
                          fontSize: "1rem",
                          color: "#64748b",
                          marginTop: "8px",
                        }}
                      >
                        per month
                      </div>
                    </div>

                    <div
                      style={{
                        backgroundColor: "#f0f9ff",
                        borderRadius: "12px",
                        padding: window.innerWidth <= 768 ? "12px" : "16px",
                        marginBottom: "20px",
                      }}
                    >
                      <div
                        style={{
                          fontSize: window.innerWidth <= 768 ? "1rem" : "1.1rem",
                          fontWeight: "700",
                          color: "#0369a1",
                          marginBottom: "8px",
                        }}
                      >
                        Included:
                      </div>
                      <div
                        style={{
                          fontSize: window.innerWidth <= 768 ? "0.9rem" : "0.95rem",
                          color: "#075985",
                          lineHeight: "1.6",
                        }}
                      >
                        Up to <strong>{tier.includedClients} clients</strong>
                        {/* <br />
                        Up to <strong>{tier.includedEmployees} employees</strong> */}
                      </div>
                    </div>

                    <div
                      style={{
                        backgroundColor: "#fef2f2",
                        borderRadius: "12px",
                        padding: window.innerWidth <= 768 ? "12px" : "14px",
                        marginBottom: "24px",
                        border: "1px solid #fecaca",
                      }}
                    >
                      <div
                        style={{
                          fontSize: window.innerWidth <= 768 ? "0.8rem" : "0.85rem",
                          color: "#991b1b",
                          fontWeight: "600",
                          marginBottom: "4px",
                        }}
                      >
                        Extra:
                      </div>
                      <div
                        style={{
                          fontSize: window.innerWidth <= 768 ? "0.85rem" : "0.9rem",
                          color: "#b91c1c",
                          lineHeight: "1.5",
                        }}
                      >
                        +R{tier.additionalClientPrice} per extra client
                        <br />
                        +R18 per employee
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      textAlign: "left",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      marginBottom: "24px",
                    }}
                  >
                    {tier.features.map((feature, fIdx) => (
                      <div
                        key={fIdx}
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "10px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "1.2rem",
                            color: "#10b981",
                            flexShrink: 0,
                          }}
                        >
                          ✓
                        </span>
                        <span
                          style={{
                            fontSize: "0.95rem",
                            color: "#475569",
                            lineHeight: "1.5",
                          }}
                        >
                          {feature}
                        </span>
                      </div>
                    ))}
                    {idx === 0 && (
                      <>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "10px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "1.2rem",
                              color: "#ef4444",
                              flexShrink: 0,
                            }}
                          >
                            ✗
                          </span>
                          <span
                            style={{
                              fontSize: "0.95rem",
                              color: "#94a3b8",
                              lineHeight: "1.5",
                            }}
                          >
                            Client Portal
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "10px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "1.2rem",
                              color: "#ef4444",
                              flexShrink: 0,
                            }}
                          >
                            ✗
                          </span>
                          <span
                            style={{
                              fontSize: "0.95rem",
                              color: "#94a3b8",
                              lineHeight: "1.5",
                            }}
                          >
                            Task Manager
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "10px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "1.2rem",
                              color: "#ef4444",
                              flexShrink: 0,
                            }}
                          >
                            ✗
                          </span>
                          <span
                            style={{
                              fontSize: "0.95rem",
                              color: "#94a3b8",
                              lineHeight: "1.5",
                            }}
                          >
                            Engagement templates
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "10px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "1.2rem",
                              color: "#ef4444",
                              flexShrink: 0,
                            }}
                          >
                            ✗
                          </span>
                          <span
                            style={{
                              fontSize: "0.95rem",
                              color: "#94a3b8",
                              lineHeight: "1.5",
                            }}
                          >
                            Working papers
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "10px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "1.2rem",
                              color: "#ef4444",
                              flexShrink: 0,
                            }}
                          >
                            ✗
                          </span>
                          <span
                            style={{
                              fontSize: "0.95rem",
                              color: "#94a3b8",
                              lineHeight: "1.5",
                            }}
                          >
                            Compliance Portal
                          </span>
                        </div>
                      </>
                    )}
                  </div>

                  <Link to="/signup">
                    <button
                      style={{
                        width: "100%",
                        padding: "16px",
                        backgroundColor: tier.popular ? "#10b981" : "#3b82f6",
                        color: "white",
                        border: "none",
                        borderRadius: "12px",
                        fontSize: "1.1rem",
                        fontWeight: "700",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = tier.popular
                          ? "#059669"
                          : "#2563eb";
                        e.target.style.transform = "translateY(-2px)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = tier.popular
                          ? "#10b981"
                          : "#3b82f6";
                        e.target.style.transform = "translateY(0)";
                      }}
                    >
                      Get Started →
                    </button>
                  </Link>
                </div>
              ))}
            </div>

            <div
              style={{
                backgroundColor: "white",
                borderRadius: "16px",
                padding: window.innerWidth <= 768 ? "16px" : "24px",
                textAlign: "center",
                border: "2px solid #fbbf24",
              }}
            >
              <p
                style={{
                  fontSize: window.innerWidth <= 768 ? "0.9rem" : "1rem",
                  color: "#78350f",
                  lineHeight: "1.6",
                  margin: 0,
                }}
              >
                💡 For practices managing multiple clients. Existing users keep current pricing.
              </p>
            </div>
          </div>

          {/* Practice Pricing Calculator */}
          <div
            style={{
              background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
              borderRadius: "24px",
              padding: window.innerWidth <= 768 ? "40px 20px" : "60px 40px",
              marginBottom: "80px",
              border: "3px solid #3b82f6",
            }}
          >
            <h2
              style={{
                fontSize: window.innerWidth <= 768 ? "1.8rem" : "2.5rem",
                fontWeight: "700",
                marginBottom: "16px",
                textAlign: "center",
                color: "#1e40af",
              }}
            >
              Practice Pricing Calculator
            </h2>
            <p
              style={{
                fontSize: window.innerWidth <= 768 ? "1rem" : "1.2rem",
                color: "#2563eb",
                textAlign: "center",
                marginBottom: "50px",
                maxWidth: "800px",
                margin: "0 auto 50px",
                lineHeight: "1.6",
              }}
            >
              Calculate your monthly costs with our all-inclusive practice
              pricing. See real-time pricing based on your clients and employees.
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: window.innerWidth <= 768 ? "1fr" : "repeat(auto-fit, minmax(320px, 1fr))",
                gap: window.innerWidth <= 768 ? "24px" : "40px",
                alignItems: "start",
              }}
            >
              {/* Controls */}
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "20px",
                  padding: window.innerWidth <= 768 ? "20px" : "32px",
                  border: "2px solid #93c5fd",
                }}
              >
                {/* Tier Selection */}
                <div style={{ marginBottom: "32px" }}>
                  <label
                    style={{
                      display: "block",
                      fontSize: window.innerWidth <= 768 ? "1rem" : "1.1rem",
                      fontWeight: "600",
                      marginBottom: "16px",
                      color: "#1e40af",
                    }}
                  >
                    Select Practice Tier
                  </label>
                  <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                    {practicePricingTiers.map((tier, idx) => (
                      <button
                        key={idx}
                        onClick={() => setSelectedPracticeTier(idx)}
                        style={{
                          padding: window.innerWidth <= 768 ? "12px" : "16px",
                          borderRadius: "12px",
                          border: selectedPracticeTier === idx ? "3px solid #3b82f6" : "2px solid #bfdbfe",
                          backgroundColor: selectedPracticeTier === idx ? "#eff6ff" : "white",
                          color: "#1e40af",
                          fontWeight: selectedPracticeTier === idx ? "700" : "600",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          textAlign: "left",
                        }}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <div>
                            <div style={{ fontSize: window.innerWidth <= 768 ? "1rem" : "1.1rem" }}>{tier.badge} {tier.name}</div>
                            <div style={{ fontSize: window.innerWidth <= 768 ? "0.8rem" : "0.85rem", color: "#2563eb", marginTop: "4px" }}>
                              {tier.includedClients} clients • Payroll: R18/employee
                            </div>
                          </div>
                          <div style={{ fontSize: "1.3rem", fontWeight: "700", color: "#1d4ed8" }}>
                            R{tier.monthlyPrice}
                          </div>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Clients Slider */}
                <div style={{ marginBottom: "32px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "16px",
                    }}
                  >
                    <label
                      style={{
                        fontSize: window.innerWidth <= 768 ? "1rem" : "1.1rem",
                        fontWeight: "600",
                        color: "#1e40af",
                      }}
                    >
                      Number of Clients
                    </label>
                    <span
                      style={{
                        fontSize: window.innerWidth <= 768 ? "1.1rem" : "1.3rem",
                        fontWeight: "700",
                        color: "#3b82f6",
                      }}
                    >
                      {practiceClients}
                    </span>
                  </div>
                  <input
                    type="range"
                    min="1"
                    max="200"
                    value={practiceClients}
                    onChange={(e) => setPracticeClients(Number(e.target.value))}
                    style={{
                      width: "100%",
                      height: "8px",
                      borderRadius: "4px",
                      outline: "none",
                      cursor: "pointer",
                      accentColor: "#3b82f6",
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "8px",
                      fontSize: "0.85rem",
                      color: "#6b7280",
                    }}
                  >
                    <span>1</span>
                    <span>200+</span>
                  </div>
                </div>

                {/* Employees Slider */}
                <div style={{ marginBottom: "32px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "16px",
                    }}
                  >
                    <label
                      style={{
                        fontSize: "1.1rem",
                        fontWeight: "600",
                        color: "#1e40af",
                      }}
                    >
                      Payroll Employees
                    </label>
                    <span
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: "700",
                        color: "#3b82f6",
                      }}
                    >
                      {practiceEmployees}
                    </span>
                  </div>
                  <input
                    type="range"
                    min="0"
                    max="50"
                    value={practiceEmployees}
                    onChange={(e) => setPracticeEmployees(Number(e.target.value))}
                    style={{
                      width: "100%",
                      height: "8px",
                      borderRadius: "4px",
                      outline: "none",
                      cursor: "pointer",
                      accentColor: "#3b82f6",
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "8px",
                      fontSize: "0.85rem",
                      color: "#6b7280",
                    }}
                  >
                    <span>0</span>
                    <span>50+</span>
                  </div>
                </div>
              </div>

              {/* Results Card */}
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "20px",
                  padding: window.innerWidth <= 768 ? "24px 20px" : "40px 36px",
                  border: "3px solid #3b82f6",
                  boxShadow: "0 20px 60px rgba(59, 130, 246, 0.2)",
                }}
              >
                <h3
                  style={{
                    fontSize: window.innerWidth <= 768 ? "1.5rem" : "1.8rem",
                    fontWeight: "700",
                    marginBottom: "24px",
                    color: "#1e40af",
                    textAlign: "center",
                  }}
                >
                  Your Monthly Estimate
                </h3>

                {(() => {
                  const selectedTier = practicePricingTiers[selectedPracticeTier];
                  const basePrice = selectedTier.monthlyPrice;
                  
                  const extraClients = Math.max(0, practiceClients - selectedTier.includedClients);
                  const extraClientsCost = extraClients * selectedTier.additionalClientPrice;
                  
                  // Employees are charged separately at R18 per employee per company
                  const employeeCost = practiceEmployees * 18;
                  
                  const totalCost = basePrice + extraClientsCost + employeeCost;
                  
                  return (
                    <>
                      <div
                        style={{
                          backgroundColor: "#eff6ff",
                          borderRadius: "16px",
                          padding: "24px",
                          marginBottom: "24px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "16px",
                            paddingBottom: "16px",
                            borderBottom: "2px solid #bfdbfe",
                          }}
                        >
                          <span style={{ fontSize: "1.05rem", color: "#1d4ed8" }}>
                            Base Price ({selectedTier.name})
                          </span>
                          <span style={{ fontSize: "1.05rem", fontWeight: "600", color: "#1e40af" }}>
                            R{basePrice.toLocaleString()}
                          </span>
                        </div>

                        {extraClients > 0 && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginBottom: "16px",
                              paddingBottom: "16px",
                              borderBottom: "2px solid #bfdbfe",
                            }}
                          >
                            <span style={{ fontSize: "1.05rem", color: "#1d4ed8" }}>
                              +{extraClients} extra client{extraClients > 1 ? 's' : ''} (R{selectedTier.additionalClientPrice} each)
                            </span>
                            <span style={{ fontSize: "1.05rem", fontWeight: "600", color: "#1e40af" }}>
                              R{extraClientsCost.toLocaleString()}
                            </span>
                          </div>
                        )}

                        {practiceEmployees > 0 && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginBottom: "16px",
                              paddingBottom: "16px",
                              borderBottom: "2px solid #bfdbfe",
                            }}
                          >
                            <span style={{ fontSize: "1.05rem", color: "#1d4ed8" }}>
                              {practiceEmployees} payroll employee{practiceEmployees > 1 ? 's' : ''} @ R18 each
                            </span>
                            <span style={{ fontSize: "1.05rem", fontWeight: "600", color: "#1e40af" }}>
                              R{employeeCost.toLocaleString()}
                            </span>
                          </div>
                        )}

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginTop: "20px",
                          }}
                        >
                          <span style={{ fontSize: window.innerWidth <= 768 ? "1.2rem" : "1.4rem", fontWeight: "700", color: "#1e40af" }}>
                            Total Monthly Cost
                          </span>
                          <div style={{ textAlign: "right" }}>
                            <div
                              style={{
                                fontSize: window.innerWidth <= 768 ? "2rem" : "2.5rem",
                                fontWeight: "800",
                                color: "#3b82f6",
                              }}
                            >
                              R{totalCost.toLocaleString()}
                            </div>
                            <div style={{ fontSize: "0.9rem", color: "#2563eb" }}>per month</div>
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          backgroundColor: "#fef2f2",
                          borderRadius: "12px",
                          padding: "16px",
                          marginBottom: "24px",
                          border: "2px solid #fecaca",
                        }}
                      >
                        <div style={{ fontSize: "0.9rem", color: "#991b1b", lineHeight: "1.6" }}>
                          <strong>Breakdown:</strong>
                          <br />• {practiceClients <= selectedTier.includedClients ? practiceClients : selectedTier.includedClients} client{(practiceClients <= selectedTier.includedClients ? practiceClients : selectedTier.includedClients) > 1 ? 's' : ''} included
                          {extraClients > 0 && ` + ${extraClients} extra`}
                          <br />• {practiceEmployees} payroll employee{practiceEmployees > 1 ? 's' : ''} @ R18 each (no free included)
                        </div>
                      </div>

                      <Link to="/signup">
                        <button
                          style={{
                            width: "100%",
                            padding: "18px",
                            backgroundColor: "#3b82f6",
                            color: "white",
                            border: "none",
                            borderRadius: "12px",
                            fontSize: "1.2rem",
                            fontWeight: "700",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#2563eb";
                            e.target.style.transform = "translateY(-2px)";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "#3b82f6";
                            e.target.style.transform = "translateY(0)";
                          }}
                        >
                          Get Started Today →
                        </button>
                      </Link>
                    </>
                  );
                })()}
              </div>
            </div>
          </div>
           {/* End hidden practice pricing calculator */}

          {false && ( // HIDING OLD SMART CALCULATOR
          <div
            style={{
              backgroundColor: isDarkMode ? "#111827" : "white",
              borderRadius: "24px",
              padding: "60px 40px",
              marginBottom: "80px",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.1)",
              border: "2px solid #e2e8f0",
            }}
          >
            <h2
              style={{
                fontSize: "2.5rem",
                fontWeight: "700",
                marginBottom: "16px",
                textAlign: "center",
                color: isDarkMode ? "#f3f4f6" : "#1e293b",
              }}
            >
              Smart Pricing Calculator
            </h2>
            <p
              style={{
                fontSize: "1.2rem",
                color: isDarkMode ? "#cbd5e1" : "#64748b",
                textAlign: "center",
                marginBottom: "50px",
                maxWidth: "800px",
                margin: "0 auto 50px",
              }}
            >
              Estimate your monthly costs and see how much you can save with our
              partner volume discounts.
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                gap: "60px",
                alignItems: "start",
              }}
            >
              {/* Controls */}
              <div>
                {/* Plan Selection */}
                <div style={{ marginBottom: "40px" }}>
                  <label
                    style={{
                      display: "block",
                      fontSize: "1.1rem",
                      fontWeight: "600",
                      marginBottom: "16px",
                      color: isDarkMode ? "#f3f4f6" : "#1e293b",
                    }}
                  >
                    Select Plan
                  </label>
                  <div
                    style={{
                      display: "flex",
                      backgroundColor: isDarkMode ? "#1f2937" : "#f1f5f9",
                      padding: "6px",
                      borderRadius: "12px",
                    }}
                  >
                    <button
                      onClick={() => setCalculatorPlan("starter")}
                      style={{
                        flex: 1,
                        padding: "12px",
                        borderRadius: "8px",
                        border: "none",
                        backgroundColor:
                          calculatorPlan === "starter"
                            ? "white"
                            : "transparent",
                        color:
                          calculatorPlan === "starter" ? "#1e293b" : "#64748b",
                        fontWeight: "600",
                        boxShadow:
                          calculatorPlan === "starter"
                            ? "0 4px 6px rgba(0,0,0,0.05)"
                            : "none",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                      }}
                    >
                      Starter (R70)
                    </button>
                    <button
                      onClick={() => setCalculatorPlan("pro")}
                      style={{
                        flex: 1,
                        padding: "12px",
                        borderRadius: "8px",
                        border: "none",
                        backgroundColor:
                          calculatorPlan === "pro" ? "white" : "transparent",
                        color: calculatorPlan === "pro" ? "#1e293b" : "#64748b",
                        fontWeight: "600",
                        boxShadow:
                          calculatorPlan === "pro"
                            ? "0 4px 6px rgba(0,0,0,0.05)"
                            : "none",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                      }}
                    >
                      Pro (R180)
                    </button>
                  </div>
                </div>

                {/* Clients Slider */}
                <div style={{ marginBottom: "40px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "16px",
                    }}
                  >
                    <label
                      style={{
                        fontSize: "1.1rem",
                        fontWeight: "600",
                        color: isDarkMode ? "#f3f4f6" : "#1e293b",
                      }}
                    >
                      Number of Clients
                    </label>
                    <span
                      style={{
                        fontSize: "1.2rem",
                        fontWeight: "700",
                        color: "#3b82f6",
                      }}
                    >
                      {calculatorClients}
                    </span>
                  </div>
                  <input
                    type="range"
                    min="1"
                    max="150"
                    value={calculatorClients}
                    onChange={(e) =>
                      setCalculatorClients(Number(e.target.value))
                    }
                    style={{
                      width: "100%",
                      height: "8px",
                      borderRadius: "4px",
                      backgroundColor: "#e2e8f0",
                      outline: "none",
                      cursor: "pointer",
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "8px",
                      fontSize: "0.85rem",
                      color: "#94a3b8",
                    }}
                  >
                    <span>1</span>
                    <span>150+</span>
                  </div>
                </div>

                {/* Employees Slider */}
                <div style={{ marginBottom: "40px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "16px",
                    }}
                  >
                    <label
                      style={{
                        fontSize: "1.1rem",
                        fontWeight: "600",
                        color: isDarkMode ? "#f3f4f6" : "#1e293b",
                      }}
                    >
                      Total Employees on Payroll
                    </label>
                    <span
                      style={{
                        fontSize: "1.2rem",
                        fontWeight: "700",
                        color: "#3b82f6",
                      }}
                    >
                      {calculatorEmployees}
                    </span>
                  </div>
                  <input
                    type="range"
                    min="0"
                    max="500"
                    value={calculatorEmployees}
                    onChange={(e) =>
                      setCalculatorEmployees(Number(e.target.value))
                    }
                    style={{
                      width: "100%",
                      height: "8px",
                      borderRadius: "4px",
                      backgroundColor: "#e2e8f0",
                      outline: "none",
                      cursor: "pointer",
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "8px",
                      fontSize: "0.85rem",
                      color: "#94a3b8",
                    }}
                  >
                    <span>0</span>
                    <span>500+</span>
                  </div>
                  <p
                    style={{
                      fontSize: "0.85rem",
                      color: "#64748b",
                      marginTop: "12px",
                      fontStyle: "italic",
                    }}
                  >
                    * {calculatorPlan === "starter" ? "2" : "10"} employees
                    included per client. Additional at R18/mo.
                  </p>
                </div>

                {/* Current Cost Comparison Input */}
                <div style={{ marginBottom: "40px" }}>
                  <label
                    style={{
                      display: "block",
                      fontSize: "1.1rem",
                      fontWeight: "600",
                      marginBottom: "16px",
                      color: isDarkMode ? "#f3f4f6" : "#1e293b",
                    }}
                  >
                    Current Monthly Accounting Software Cost (Optional)
                  </label>
                  <div style={{ position: "relative" }}>
                    <span
                      style={{
                        position: "absolute",
                        left: "16px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#64748b",
                        fontWeight: "600",
                      }}
                    >
                      R
                    </span>
                    <input
                      type="number"
                      placeholder="e.g. 15000"
                      value={currentMonthlyCost}
                      onChange={(e) =>
                        setCurrentMonthlyCost(Number(e.target.value))
                      }
                      style={{
                        width: "100%",
                        padding: "12px 16px 12px 40px",
                        borderRadius: "12px",
                        border: "1px solid #e2e8f0",
                        fontSize: "1rem",
                        outline: "none",
                        backgroundColor: isDarkMode ? "#374151" : "white",
                        color: isDarkMode ? "#f3f4f6" : "#1e293b",
                      }}
                    />
                  </div>
                  <p
                    style={{
                      fontSize: "0.85rem",
                      color: "#64748b",
                      marginTop: "8px",
                    }}
                  >
                    Enter what you currently pay for Xero, Sage, or QuickBooks
                    to see your potential savings.
                  </p>
                </div>
              </div>

              {/* Results */}
              <div
                style={{
                  backgroundColor: isDarkMode ? "#1f2937" : "#f8fafc",
                  borderRadius: "20px",
                  padding: "30px",
                  border: "1px solid #e2e8f0",
                }}
              >
                {(() => {
                  const basePrice = calculatorPlan === "starter" ? 70 : 180;
                  const clientSubtotal = basePrice * calculatorClients;

                  // Payroll Calculation
                  const includedPerClient =
                    calculatorPlan === "starter" ? 2 : 10;
                  const totalIncluded = calculatorClients * includedPerClient;
                  const billableEmployees = Math.max(
                    0,
                    calculatorEmployees - totalIncluded
                  );
                  const payrollCost = billableEmployees * 18;

                  const subtotal = clientSubtotal + payrollCost;

                  let discountPercent = 0;
                  let tierName = "Bronze";

                  if (calculatorClients >= 101) {
                    discountPercent = 50;
                    tierName = "Platinum";
                  } else if (calculatorClients >= 51) {
                    discountPercent = 40;
                    tierName = "Gold";
                  } else if (calculatorClients >= 25) {
                    discountPercent = 20;
                    tierName = "Silver";
                  }

                  const discountAmount = subtotal * (discountPercent / 100);
                  const total = subtotal - discountAmount;
                  const pricePerClient = total / calculatorClients;
                  const potentialSavings =
                    currentMonthlyCost > 0 ? currentMonthlyCost - total : 0;

                  return (
                    <>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "8px",
                          color: "#64748b",
                          fontSize: "0.95rem",
                        }}
                      >
                        <span>Client Subtotal</span>
                        <span>R{clientSubtotal.toLocaleString()}</span>
                      </div>

                      {payrollCost > 0 && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "8px",
                            color: "#64748b",
                            fontSize: "0.95rem",
                          }}
                        >
                          <span>
                            Payroll ({billableEmployees} billable @ R18)
                          </span>
                          <span>R{payrollCost.toLocaleString()}</span>
                        </div>
                      )}

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "16px",
                          paddingBottom: "16px",
                          borderBottom: "1px solid #e2e8f0",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "600",
                            color: isDarkMode ? "#f3f4f6" : "#1e293b",
                          }}
                        >
                          Subtotal
                        </span>
                        <span
                          style={{
                            fontWeight: "600",
                            color: isDarkMode ? "#f3f4f6" : "#1e293b",
                          }}
                        >
                          R{subtotal.toLocaleString()}
                        </span>
                      </div>

                      {discountPercent > 0 && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "16px",
                            paddingBottom: "16px",
                            borderBottom: "1px solid #e2e8f0",
                            color: "#059669",
                          }}
                        >
                          <span>
                            {tierName} Discount ({discountPercent}%)
                          </span>
                          <span style={{ fontWeight: "600" }}>
                            -R{discountAmount.toLocaleString()}
                          </span>
                        </div>
                      )}

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "baseline",
                          marginBottom: "8px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "1.2rem",
                            fontWeight: "700",
                            color: isDarkMode ? "#f3f4f6" : "#1e293b",
                          }}
                        >
                          Total Monthly
                        </span>
                        <span
                          style={{
                            fontSize: "2.5rem",
                            fontWeight: "800",
                            color: "#3b82f6",
                          }}
                        >
                          R{total.toLocaleString()}
                        </span>
                      </div>

                      <div
                        style={{
                          textAlign: "right",
                          fontSize: "0.9rem",
                          color: "#64748b",
                          marginBottom: "24px",
                        }}
                      >
                        Effective price: R{pricePerClient.toFixed(0)}
                        /client
                      </div>

                      {potentialSavings > 0 && (
                        <div
                          style={{
                            backgroundColor: "#dcfce7",
                            borderRadius: "16px",
                            padding: "20px",
                            marginBottom: "24px",
                            border: "2px solid #86efac",
                            textAlign: "center",
                            animation: "pulse 2s infinite",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "1rem",
                              color: "#065f46",
                              fontWeight: "700",
                              marginBottom: "4px",
                              textTransform: "uppercase",
                              letterSpacing: "1px",
                            }}
                          >
                            You Could Save
                          </div>
                          <div
                            style={{
                              fontSize: "2.5rem",
                              fontWeight: "800",
                              color: "#059669",
                              lineHeight: "1",
                              marginBottom: "8px",
                            }}
                          >
                            R{potentialSavings.toLocaleString()}
                          </div>
                          <div
                            style={{
                              fontSize: "0.9rem",
                              color: "#047857",
                            }}
                          >
                            per month by switching to FilingStack
                          </div>
                        </div>
                      )}

                      <div
                        style={{
                          backgroundColor: "#eff6ff",
                          borderRadius: "12px",
                          padding: "16px",
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "0.9rem",
                            color: "#1e40af",
                            fontWeight: "600",
                            marginBottom: "4px",
                          }}
                        >
                          Your Partner Status
                        </div>
                        <div
                          style={{
                            fontSize: "1.5rem",
                            fontWeight: "800",
                            color: "#2563eb",
                          }}
                        >
                          {tierName} Partner
                        </div>
                      </div>
                    </>
                  );
                })()}
              </div>
            </div>
          </div>
          )} {/* END HIDDEN OLD SMART CALCULATOR */}

          {/* Prepaid PDF Credit Packs */}
          {/* <div style={{ marginBottom: "80px" }}>
            <h2
              style={{
                fontSize: "2rem",
                fontWeight: "700",
                marginBottom: "16px",
                textAlign: "center",
                color: "#1e293b",
              }}
            >
              PDF Bank Statement Conversion
            </h2>
            <p
              style={{
                fontSize: "1.1rem",
                color: "#64748b",
                textAlign: "center",
                marginBottom: "40px",
                maxWidth: "700px",
                margin: "0 auto 40px",
              }}
            >
              One-time prepaid credit packs. No monthly fees. Buy only what you
              need.
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                gap: "24px",
              }}
            >
              {pdfCreditPacks.map((pack, idx) => (
                <div
                  key={idx}
                  style={{
                    backgroundColor: isDarkMode ? "#111827" : "white",
                    color: isDarkMode ? "#f3f4f6" : "inherit",
                    borderRadius: "20px",
                    padding: "30px 24px",
                    border: pack.popular
                      ? "3px solid #10b981"
                      : "2px solid #e2e8f0",
                    boxShadow: pack.popular
                      ? "0 10px 40px rgba(16, 185, 129, 0.2)"
                      : "0 4px 15px rgba(0, 0, 0, 0.05)",
                    position: "relative",
                  }}
                >
                  {pack.popular && (
                    <div
                      style={{
                        position: "absolute",
                        top: "-12px",
                        right: "20px",
                        backgroundColor: "#10b981",
                        color: "white",
                        padding: "4px 12px",
                        borderRadius: "12px",
                        fontSize: "0.75rem",
                        fontWeight: "700",
                      }}
                    >
                      BEST VALUE
                    </div>
                  )}
                  {pack.savings && (
                    <div
                      style={{
                        backgroundColor: "#dcfce7",
                        color: "#065f46",
                        padding: "6px 12px",
                        borderRadius: "20px",
                        fontSize: "0.8rem",
                        fontWeight: "700",
                        display: "inline-block",
                        marginBottom: "16px",
                      }}
                    >
                      {pack.savings}
                    </div>
                  )}
                  <h4
                    style={{
                      fontSize: "1.2rem",
                      fontWeight: "700",
                      color: isDarkMode ? "#f3f4f6" : "#1e293b",
                      marginBottom: "8px",
                    }}
                  >
                    {pack.badge} Pack
                  </h4>
                  <div
                    style={{
                      fontSize: "2.5rem",
                      fontWeight: "800",
                        color: isDarkMode ? "#f3f4f6" : "#1e293b",
                      marginBottom: "8px",
                    }}
                  >
                    {pack.pages.toLocaleString()}
                  </div>
                  <div
                    style={{
                      fontSize: "0.9rem",
                      color: "#64748b",
                      marginBottom: "16px",
                        color: isDarkMode ? "#f3f4f6" : "#1e293b",
                  >
                    pages
                  </div>
                  <div
                    style={{
                      fontSize: "1.8rem",
                      fontWeight: "700",
                      color: "#1e293b",
                      marginBottom: "4px",
                    }}
                  >
                    R{pack.price.toLocaleString()}
                  </div>
                  <div
                    style={{
                      fontSize: "0.85rem",
                      color: "#64748b",
                      marginBottom: "20px",
                    }}
                  >
                    R{pack.pricePerPage.toFixed(2)} per page
                  </div>
                  <button
                    style={{
                      width: "100%",
                      padding: "14px",
                      backgroundColor: pack.popular ? "#10b981" : "#3b82f6",
                      color: "white",
                      border: "none",
                      borderRadius: "10px",
                      fontSize: "1rem",
                      fontWeight: "700",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = pack.popular
                        ? "#059669"
                        : "#2563eb";
                      e.target.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = pack.popular
                        ? "#10b981"
                        : "#3b82f6";
                      e.target.style.transform = "translateY(0)";
                    }}
                  >
                    Purchase Pack
                  </button>
                </div>
              ))}
            </div>

            <div
              style={{
                backgroundColor: "#fffbeb",
                borderLeft: "4px solid #f59e0b",
                padding: "20px",
                borderRadius: "12px",
                marginTop: "30px",
              }}
            >
              <p
                style={{
                  color: "#92400e",
                  fontSize: "0.95rem",
                  lineHeight: "1.6",
                  margin: 0,
                }}
              >
                <strong>💡 How it works:</strong> Purchase a credit pack once.
                Credits never expire. Use them across all your clients. Need
                more? Buy another pack anytime.
              </p>
            </div>
          </div> */}

          {/* Free FilingStack Command Center */}
          <div
            style={{
              backgroundColor: "#f0fdf4",
              borderRadius: "20px",
              padding: "40px",
              border: "2px solid #bbf7d0",
              textAlign: "center",
            }}
          >
            <div style={{ fontSize: "3rem", marginBottom: "16px" }}>🎁</div>
            <h3
              style={{
                fontSize: "1.8rem",
                fontWeight: "700",
                color: "#065f46",
                marginBottom: "12px",
              }}
            >
              FilingStack Command Center: Always Free
            </h3>
            <p
              style={{
                fontSize: "1.1rem",
                color: "#047857",
                maxWidth: "700px",
                margin: "0 auto",
                lineHeight: "1.6",
              }}
            >
              Track all clients (even unpaid ones), monitor CIPC & SARS
              deadlines, and manage your practice workflow. No cost, no limits.
            </p>
          </div>

          {/* Interactive Pricing Calculator */}
          {/* <div
            style={{
              background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
              borderRadius: "24px",
              padding: "60px 40px",
              marginTop: "60px",
              marginBottom: "60px",
              border: "3px solid #fbbf24",
              boxShadow: "0 20px 60px rgba(251, 191, 36, 0.3)",
            }}
          >
            <div style={{ textAlign: "center", marginBottom: "40px" }}>
              <div style={{ fontSize: "3rem", marginBottom: "16px" }}>🧮</div>
              <h2
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "700",
                      color: isDarkMode ? "#f3f4f6" : "#1e293b",
                  color: "#78350f",
                }}
              >
                Calculate Your Savings
              </h2>
              <p
                style={{
                  fontSize: "1.2rem",
                  color: "#92400e",
                  maxWidth: "700px",
                  margin: "0 auto",
                  lineHeight: "1.6",
                }}
              >
                See exactly how much you save with our partner pricing vs. traditional per-client software costs
              </p>
            </div>

            
            <div
              style={{
                backgroundColor: isDarkMode ? "#111827" : "white",
                color: isDarkMode ? "#f3f4f6" : "inherit",
                borderRadius: "16px",
                padding: "40px",
                maxWidth: "900px",
                margin: "0 auto",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              }}
            >
             
              <div style={{ marginBottom: "30px" }}>
                <label
                  style={{
                    display: "block",
                    fontSize: "1.1rem",
                    fontWeight: "600",
                    color: "#1e293b",
                    marginBottom: "12px",
                  }}
                >
                  Select Plan:
                </label>
                <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
                  <button
                    onClick={() => setCalculatorPlan("starter")}
                    style={{
                      flex: 1,
                      minWidth: "200px",
                      padding: "16px 24px",
                      backgroundColor: calculatorPlan === "starter" ? "#3b82f6" : "#e2e8f0",
                      color: calculatorPlan === "starter" ? "white" : "#475569",
                      border: "none",
                      borderRadius: "12px",
                      fontSize: "1rem",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                  >
                    FilingStack Starter (R70/client)
                  </button>
                  <button
                    onClick={() => setCalculatorPlan("pro")}
                    style={{
                      flex: 1,
                      minWidth: "200px",
                      padding: "16px 24px",
                      backgroundColor: calculatorPlan === "pro" ? "#3b82f6" : "#e2e8f0",
                      color: calculatorPlan === "pro" ? "white" : "#475569",
                      border: "none",
                      borderRadius: "12px",
                      fontSize: "1rem",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                  >
                    FilingStack Pro (R180/client)
                  </button>
                </div>
              </div>

            
              <div style={{ marginBottom: "30px" }}>
                <label
                  style={{
                    display: "block",
                    fontSize: "1.1rem",
                    fontWeight: "600",
                    color: "#1e293b",
                    marginBottom: "12px",
                  }}
                >
                  Number of Clients: <span style={{ color: "#3b82f6", fontSize: "1.4rem" }}>{calculatorClients}</span>
                </label>
                <input
                  type="range"
                  min="5"
                  max="150"
                  value={calculatorClients}
                  onChange={(e) => setCalculatorClients(Number(e.target.value))}
                  style={{
                    width: "100%",
                    height: "8px",
                    borderRadius: "4px",
                    outline: "none",
                    cursor: "pointer",
                  }}
                />
                <div style={{ display: "flex", justifyContent: "space-between", marginTop: "8px" }}>
                  <span style={{ fontSize: "0.9rem", color: "#64748b" }}>5 clients</span>
                  <span style={{ fontSize: "0.9rem", color: "#64748b" }}>150 clients</span>
                </div>
              </div>

           
              {(() => {
                const pricePerClient = calculatorPlan === "starter" ? 70 : 180;
                const basePrice = calculatorClients * pricePerClient;
                
                // Determine partner tier
                let discount = 0;
                let tierName = "Bronze Partner";
                let tierBadge = "🥉";
                if (calculatorClients >= 101) {
                  discount = 0.5;
                  tierName = "Platinum Partner";
                  tierBadge = "💎";
                } else if (calculatorClients >= 51) {
                  discount = 0.4;
                  tierName = "Gold Partner";
                  tierBadge = "🥇";
                } else if (calculatorClients >= 25) {
                  discount = 0.2;
                  tierName = "Silver Partner";
                  tierBadge = "🥈";
                }

                const discountedPrice = basePrice * (1 - discount);
                const savings = basePrice - discountedPrice;

                // Competition pricing (typical R300-500 per client for similar software)
                const competitionPrice = calculatorClients * (calculatorPlan === "starter" ? 200 : 450);
                const competitionSavings = competitionPrice - discountedPrice;
                const competitionAnnualSavings = competitionSavings * 12;

                return (
                  <>
                   
                    <div
                      style={{
                        backgroundColor: "#f0f9ff",
                        borderRadius: "12px",
                        padding: "20px",
                        marginBottom: "24px",
                        border: "2px solid #3b82f6",
                        textAlign: "center",
                      }}
                    >
                      <div style={{ fontSize: "2.5rem", marginBottom: "8px" }}>{tierBadge}</div>
                      <div style={{ fontSize: "1.3rem", fontWeight: "700", color: "#1e293b" }}>
                        Your Tier: {tierName}
                      </div>
                      {discount > 0 && (
                        <div style={{ fontSize: "1.1rem", color: "#059669", fontWeight: "600", marginTop: "4px" }}>
                          {(discount * 100).toFixed(0)}% Discount Applied
                        </div>
                      )}
                    </div>

                 
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "16px", marginBottom: "30px" }}>
                      <div style={{ backgroundColor: "#f8fafc", borderRadius: "12px", padding: "20px", textAlign: "center" }}>
                        <div style={{ fontSize: "0.9rem", color: "#64748b", marginBottom: "8px" }}>Base Price</div>
                        <div style={{ fontSize: "1.8rem", fontWeight: "700", color: "#475569" }}>R{basePrice.toLocaleString()}</div>
                        <div style={{ fontSize: "0.85rem", color: "#94a3b8" }}>per month</div>
                      </div>
                      
                      <div style={{ backgroundColor: "#ecfdf5", borderRadius: "12px", padding: "20px", textAlign: "center", border: "2px solid #10b981" }}>
                        <div style={{ fontSize: "0.9rem", color: "#059669", marginBottom: "8px" }}>Your Price</div>
                        <div style={{ fontSize: "1.8rem", fontWeight: "700", color: "#059669" }}>R{discountedPrice.toLocaleString()}</div>
                        <div style={{ fontSize: "0.85rem", color: "#059669" }}>per month</div>
                      </div>
                      
                      {discount > 0 && (
                        <div style={{ backgroundColor: "#fef3c7", borderRadius: "12px", padding: "20px", textAlign: "center" }}>
                          <div style={{ fontSize: "0.9rem", color: "#92400e", marginBottom: "8px" }}>You Save</div>
                          <div style={{ fontSize: "1.8rem", fontWeight: "700", color: "#92400e" }}>R{savings.toLocaleString()}</div>
                          <div style={{ fontSize: "0.85rem", color: "#92400e" }}>per month</div>
                        </div>
                      )}
                    </div>

              
                    <div
                      style={{
                        background: "linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)",
                        borderRadius: "12px",
                        padding: "24px",
                        border: "2px solid #f87171",
                      }}
                    >
                      <h3 style={{ fontSize: "1.3rem", fontWeight: "700", color: "#991b1b", marginBottom: "16px", textAlign: "center" }}>
                        💰 vs. Traditional Software Pricing
                      </h3>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                        <div style={{ textAlign: "center" }}>
                          <div style={{ fontSize: "0.9rem", color: "#991b1b", marginBottom: "8px" }}>Competition</div>
                          <div style={{ fontSize: "1.6rem", fontWeight: "700", color: "#991b1b", textDecoration: "line-through" }}>
                            R{competitionPrice.toLocaleString()}
                          </div>
                          <div style={{ fontSize: "0.8rem", color: "#991b1b" }}>per month</div>
                        </div>
                        <div style={{ textAlign: "center" }}>
                          <div style={{ fontSize: "0.9rem", color: "#059669", marginBottom: "8px" }}>FilingStack</div>
                          <div style={{ fontSize: "1.6rem", fontWeight: "700", color: "#059669" }}>
                            R{discountedPrice.toLocaleString()}
                          </div>
                          <div style={{ fontSize: "0.8rem", color: "#059669" }}>per month</div>
                        </div>
                      </div>
                      <div
                        style={{
                          marginTop: "20px",
                          paddingTop: "20px",
                          borderTop: "1px solid #fca5a5",
                          textAlign: "center",
                        }}
                      >
                        <div style={{ fontSize: "1rem", color: "#991b1b", marginBottom: "8px" }}>Additional Savings vs. Competition:</div>
                        <div style={{ fontSize: "2rem", fontWeight: "700", color: "#059669" }}>
                          R{competitionSavings.toLocaleString()}/month
                        </div>
                        <div style={{ fontSize: "1.3rem", fontWeight: "600", color: "#059669", marginTop: "8px" }}>
                          R{competitionAnnualSavings.toLocaleString()}/year 🎉
                        </div>
                      </div>
                    </div>
                  </>
                );
              })()}
            </div>
          </div> */}

          <div style={{ marginTop: "40px", textAlign: "center" }}>
            <button
              onClick={() => setView("segment")}
              style={{
                fontSize: "1rem",
                color: isDarkMode ? "#cbd5e1" : "#64748b",
                border: "none",
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              ← Back to Options
            </button>
          </div>
        </div>
      )}

      {/* BUSINESS VIEW */}
      {view === "business" && (
        <div style={{ backgroundColor: "#f8fafc", padding: "80px 20px" }}>
          <div
            style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center" }}
          >
            <h1
              style={{
                fontSize: "clamp(2rem, 4vw, 2.5rem)",
                fontWeight: "700",
                marginBottom: "20px",
                color: isDarkMode ? "#132548ff" : "#1e293b",
              }}
            >
              Business Pricing
            </h1>
            <p
              style={{
                fontSize: "1.2rem",
                color: isDarkMode ? "#0f243eff" : "#64748b",
                marginBottom: "50px",
                lineHeight: "1.6",
                maxWidth: "700px",
                margin: "0 auto 50px auto",
              }}
            >
              Everything you need to manage your finances.
            </p>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "30px",
                alignItems: "flex-start",
              }}
            >
              {/* FREE TIER */}
              <div
                style={{
                  flex: "1",
                  minWidth: "300px",
                  maxWidth: "450px",
                  backgroundColor: isDarkMode ? "#111827" : "white",
                  color: isDarkMode ? "#f3f4f6" : "inherit",
                  borderRadius: "24px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.05)",
                  border: "1px solid #e2e8f0",
                  position: "relative",
                }}
              >
                <h2
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    marginBottom: "10px",
                    color: isDarkMode ? "#f3f4f6" : "#1e293b",
                  }}
                >
                  FilingStack Free
                </h2>
                <p style={{ color: isDarkMode ? "#9ca3af" : "#64748b", marginBottom: "20px" }}>
                  Essential tools for small businesses
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    justifyContent: "center",
                    gap: "8px",
                    marginBottom: "30px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "3.5rem",
                      fontWeight: "800",
                      color: "#1e293b",
                    }}
                  >
                    R0
                  </div>
                  <div
                    style={{
                      fontSize: "1.1rem",
                      color: isDarkMode ? "#cbd5e1" : "#64748b",
                      fontWeight: "500",
                    }}
                  >
                    / month
                  </div>
                </div>
                <Link to="/signup">
                  <button
                    style={{
                      width: "100%",
                      padding: "16px",
                      backgroundColor: isDarkMode ? "#374151" : "#f1f5f9",
                      color: isDarkMode ? "white" : "#334155",
                      border: "none",
                      borderRadius: "12px",
                      fontSize: "1.1rem",
                      fontWeight: "700",
                      cursor: "pointer",
                      marginBottom: "30px",
                      transition: "all 0.3s ease",
                    }}
                  >
                    Get Started Free
                  </button>
                </Link>
                <div style={{ textAlign: "left", display: "flex", flexDirection: "column", gap: "12px" }}>
                  {[
                    "Create up to 5 invoices",
                    "Professional invoice templates",
                    "Client Management",
                  ].map((feature, index) => (
                    <div key={index} style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#64748b" viewBox="0 0 16 16" style={{ flexShrink: 0, marginTop: "2px" }}>
                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                      </svg>
                      <span style={{ fontSize: "0.95rem", color: isDarkMode ? "#cbd5e1" : "#475569" }}>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* BUSINESS TIER */}
              <div
                style={{
                  flex: "1",
                  minWidth: "300px",
                  maxWidth: "450px",
                  backgroundColor: isDarkMode ? "#111827" : "white",
                  color: isDarkMode ? "#f3f4f6" : "inherit",
                  borderRadius: "24px",
                  padding: "40px",
                  boxShadow: "0 20px 60px rgba(0, 0, 0, 0.1)",
                  border: "2px solid #059669",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "#059669",
                    color: "white",
                    padding: "4px 16px",
                    borderRadius: "20px",
                    fontSize: "0.85rem",
                    fontWeight: "700",
                    textTransform: "uppercase",
                    letterSpacing: "1px",
                  }}
                >
                  Most Popular
                </div>
                <h2
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    marginBottom: "10px",
                    color: isDarkMode ? "#f3f4f6" : "#1e293b",
                  }}
                >
                  FilingStack Business
                </h2>
                <p style={{ color: isDarkMode ? "#9ca3af" : "#64748b", marginBottom: "20px" }}>
                  Full power for growing companies
                </p>
                
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    justifyContent: "center",
                    gap: "8px",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "3.5rem",
                      fontWeight: "800",
                      color: "#059669",
                    }}
                  >
                    R199
                  </div>
                  <div
                    style={{
                      fontSize: "1.1rem",
                      color: isDarkMode ? "#cbd5e1" : "#64748b",
                      fontWeight: "500",
                    }}
                  >
                    / month
                  </div>
                </div>
                <div style={{ fontSize: "0.9rem", color: "#64748b", marginBottom: "30px" }}>
                  including VAT
                </div>

                <Link to="/signup">
                  <button
                    style={{
                      width: "100%",
                      padding: "16px",
                      backgroundColor: "#059669",
                      color: "white",
                      border: "none",
                      borderRadius: "12px",
                      fontSize: "1.1rem",
                      fontWeight: "700",
                      cursor: "pointer",
                      marginBottom: "30px",
                      transition: "all 0.3s ease",
                    }}
                  >
                    Start 30-Day Free Trial
                  </button>
                </Link>

                <div style={{ textAlign: "left", display: "flex", flexDirection: "column", gap: "12px" }}>
                  {[
                    "Everything in Free",
                    "Unlimited invoices & quotations",
                    "Invoice scanning & capture (usage billed separately)",
                    "Full payroll suite (10 employees included)",
                    "AI-powered bookkeeping",
                    "VAT reports & Tax calculations",
                    "Comprehensive financial statements",
                    "CIPC reminders & client approvals",
                    "Accountant collaboration",
                  ].map((feature, index) => (
                    <div key={index} style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#059669" viewBox="0 0 16 16" style={{ flexShrink: 0, marginTop: "2px" }}>
                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                      </svg>
                      <span style={{ fontSize: "0.95rem", color: isDarkMode ? "#cbd5e1" : "#475569" }}>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div
              style={{
                marginTop: "60px",
                maxWidth: "800px",
                marginLeft: "auto",
                marginRight: "auto",
                backgroundColor: isDarkMode ? "#1e3a5f" : "#dbeafe",
                borderLeft: "4px solid #3b82f6",
                padding: "24px",
                borderRadius: "12px",
                textAlign: "left",
              }}
            >
              <h3
                style={{
                  fontWeight: "700",
                  color: isDarkMode ? "#93c5fd" : "#1e3a8a",
                  marginBottom: "8px",
                  fontSize: "1.1rem",
                }}
              >
                Working with an accountant?
              </h3>
              <p
                style={{
                  color: isDarkMode ? "#bfdbfe" : "#1e40af",
                  lineHeight: "1.6",
                }}
              >
                Contact your accountant about adding you to their FilingStack
                practice. Software access may be included in their service
                offering.
              </p>
            </div>

            <div style={{ marginTop: "40px" }}>
              <button
                onClick={() => setView("segment")}
                style={{
                  fontSize: "1rem",
                  color: isDarkMode ? "#cbd5e1" : "#64748b",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                ← Back to Options
              </button>
            </div>
          </div>
        </div>
      )}

      {/* FAQ Section */}
      <div
        style={{
          backgroundColor: isDarkMode ? "#111827" : "white",
          color: isDarkMode ? "#f3f4f6" : "inherit",
          padding: "100px 20px",
        }}
      >
        <div
          style={{
            maxWidth: "1000px",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              textAlign: "center",
              marginBottom: "60px",
            }}
          >
            <h2
              style={{
                fontSize: "clamp(2rem, 4vw, 3rem)",
                fontWeight: "700",
                color: isDarkMode ? "#f3f4f6" : "#1e293b",
                marginBottom: "20px",
                fontFamily:
                  "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
              }}
            >
              Frequently Asked Questions
            </h2>
            <p
              style={{
                fontSize: "1.2rem",
                color: isDarkMode ? "#cbd5e1" : "#64748b",
                maxWidth: "600px",
                margin: "0 auto",
                lineHeight: "1.6",
              }}
            >
              Everything you need to know about our pricing and plans
            </p>
          </div>

          {QuestionAnswer(
            "How do Practice Tier Plans work?",
            `Choose between three all-inclusive tiers: Starter (R399/mo, 10 clients), Growth (R1,499/mo, 50 clients), or Enterprise (R3,499/mo, 150 clients). Each tier includes a base number of clients with overage charges for additional clients (R50 per extra client). Payroll is charged separately at R18 per employee per company. This provides predictable pricing that scales with your practice.`,
            1
          )}
          {QuestionAnswer(
            "What if I exceed my tier's client limit?",
            `No problem! You'll be charged for additional clients at your tier's overage rate (R50 per extra client). You can also purchase additional client slots upfront for smoother monthly billing. If you consistently exceed your tier, consider upgrading to the next tier for better value.`,
            2
          )}
          {QuestionAnswer(
            "How do prepaid PDF credit packs work?",
            `Purchase a credit pack once (500-10,000 pages) at discounted rates (R1.60-R2.00/page). Credits never expire and can be used across all your clients. Simply upload PDF bank statements, and credits are deducted automatically. When you run low, purchase another pack.`,
            3
          )}
          {QuestionAnswer(
            "What's included in the FREE FilingStack Command Center?",
            `FilingStack Command Center is 100% free forever and includes: (1) Client database (unlimited clients), (2) CIPC Annual Returns deadline tracking, (3) SARS submission monitoring, (4) Practice management dashboard, and (5) Staff collaboration tools. You can use FilingStack Command Center for ALL your clients, even those without paid subscriptions.`,
            4
          )}
          {QuestionAnswer(
            "Can I mix different pricing models?",
            `Yes! Existing practices can continue using per-client pricing (FilingStack Starter at R70/client or Pro at R180/client), while new practices can choose all-inclusive Practice Tier plans. However, you cannot combine both models - choose the one that works best for your practice size and growth plans.`,
            5
          )}
          {QuestionAnswer(
            "How does payroll pricing work?",
            `FilingStack Business includes the full payroll suite for up to 10 employees. Additional employees are R18 per employee per month.`,
            6
          )}
          {QuestionAnswer(
            "What does CIPC Automation do?",
            `Manage annual-return and beneficial-ownership reminders, follow-ups, secure client approvals, multi-year fee quotes, attachments, weekly summaries and saved progress. Your team submits filings through CIPC and records the outcome in FilingStack. Marking Billed does not create an invoice. CIPC and practice service fees are separate from your software subscription; automated emails require setup and activation.`,
            7
          )}
        </div>
      </div>

      <div>
        <Footer />
      </div>
    </div>
  );
}

export default Pricing;
